import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const MILESTONES = ['$2', '$20', '$200', '$2,000', '$20,000', '$200,000', '$2,000,000', '$20,000,000', '$200,000,000', '$2,000,000,000', '$20,000,000,000', '$200,000,000,000', '$2,000,000,000,000'];
function AnimatedAmount() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    // Speed: fast in the middle, slower at start and end
    const getDelay = (i: number) => {
      if (i < 2) return 300;
      if (i < 5) return 180;
      if (i < 9) return 120;
      if (i < 11) return 180;
      if (i === MILESTONES.length - 1) return 3000; // hold on final number
      return 250;
    };
    const timeout = setTimeout(() => {
      setIndex(prev => (prev + 1) % MILESTONES.length);
    }, getDelay(index));
    return () => clearTimeout(timeout);
  }, [index]);
  const displayed = MILESTONES[index];
  const isAtEnd = index === MILESTONES.length - 1;
  return <span className="relative inline-block" data-id="element-121">
      <motion.span key={index} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.2,
      ease: 'easeOut'
    }} className="font-serif font-bold text-brand-teal" data-id="element-122">
        {displayed}
      </motion.span>
      {isAtEnd && <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="absolute -bottom-2 left-0 right-0 h-[3px] bg-brand-teal/40 origin-left rounded-full" data-id="element-123" />}
    </span>;
}
export function Hero() {
  const scrollToNotify = () => {
    const element = document.getElementById('notify-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-brand-white" data-id="element-124">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-126">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.15] text-brand-black mb-6" data-id="element-127">
            <AnimatedAmount data-id="element-128" />
            <br data-id="element-129" />
            <span className="text-brand-black" data-id="element-130">
              in business assets are changing hands in the next decade.
            </span>
          </h1>

          <div className="space-y-4 text-lg md:text-xl text-gray-600 mb-8 font-light leading-relaxed" data-id="element-131">
            <p className="font-medium text-brand-black" data-id="element-132">
              But who gets access to business ownership? Who gets to acquire?
              Who gets to build generational wealth? Who gets to continue the
              legacy?
            </p>
            <p data-id="element-133">
              Inclusive Succession explores these questions through the lived
              experiences of diverse entrepreneurs who have successfully bought
              and sold businesses.
            </p>
            <p className="font-serif italic text-2xl text-brand-tealDark pt-4" data-id="element-134">
              This is not just research. This is a blueprint for economic
              inclusion.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-135">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToNotify} className="relative group bg-brand-teal text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:bg-brand-tealDark transition-all duration-300 overflow-hidden" data-id="element-136">
              <span className="relative z-10" data-id="element-137">
                Get Notified When Report Goes Live
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-138"></div>
            </motion.button>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToNotify} className="px-8 py-4 rounded-full font-semibold text-lg border-2 border-brand-black text-brand-black hover:bg-brand-black hover:text-white transition-all duration-300" data-id="element-139">
              Join the Launch Event Waitlist
            </motion.button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="relative lg:h-[800px] flex items-center justify-center" data-id="element-140">
          <motion.div animate={{
          y: [-15, 15, -15]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative w-full max-w-lg mx-auto shadow-2xl rounded-lg overflow-hidden" data-id="element-141">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-teal/20 to-transparent mix-blend-overlay z-10" data-id="element-142"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cmBoPB2uv3LpvbBEmEK58S/ETA_Study.png" alt="ETA Inclusive Succession Study Cover" className="w-full h-auto object-cover" data-id="element-143" />
          </motion.div>

          {/* Decorative background elements */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-teal/5 rounded-full blur-3xl -z-10" data-id="element-144"></div>
        </motion.div>
      </div>
    </section>;
}